import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Alert, Input } from 'reactstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import FormCard from '../forms/FormCard';
import { isNovertejumsEditableByUser, parseListResult } from './riskaNovertejumsUtils';
import {
    loadRiskaNovertejumuPasakumi,
    loadRiskaPreventiviePasakumi,
    saveRiskaNovertejumaPasakums,
    deleteRiskaNovertejumaPasakums,
    loadRiskaNovertejums
} from '../../actions/dzeramaUdensSatecesBaseiniActions';

class RiskaNovertejumsPasakumi extends Component {
    state = {
        preventiviePasakumi: [],
        ietekmesPasakumi: [],
        editingId: null,
        apraksts: ''
    };

    componentDidMount() {
        this.loadData();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.id !== this.props.id) {
            this.loadData();
        }
    }

    loadData = () => {
        const { id, loadRiskaNovertejumuPasakumi, loadRiskaPreventiviePasakumi } = this.props;
        if (id) {
            loadRiskaNovertejumuPasakumi(id).then(result => {
                this.setState({ ietekmesPasakumi: parseListResult(result) });
            }).catch(() => {});
        }
        loadRiskaPreventiviePasakumi().then(result => {
            this.setState({ preventiviePasakumi: parseListResult(result) });
        }).catch(() => {});
    }

    handleSave = () => {
        const { saveRiskaNovertejumaPasakums, loadRiskaNovertejums, id } = this.props;
        const { editingId, apraksts } = this.state;

        saveRiskaNovertejumaPasakums(id, apraksts, editingId)
            .then(() => {
                this.setState({ editingId: null, apraksts: '' });
                this.loadData();
                loadRiskaNovertejums(id);
            });
    }

    handleDelete = (pasakumsId) => {
        if (!window.confirm('Vai tiešām vēlaties dzēst šo pasākumu?')) return;

        const { deleteRiskaNovertejumaPasakums, loadRiskaNovertejums, id } = this.props;
        deleteRiskaNovertejumaPasakums(pasakumsId)
            .then(() => {
                this.loadData();
                loadRiskaNovertejums(id);
            })
            .catch((error) => {
                alert('Kļūda dzēšot pasākumu: ' + error.message);
            });
    }

    getIetekmesPasakumiColumns = (isEditable) => {
        const columns = [
            { dataField: 'apraksts', text: 'Pasākuma apraksts' },
            {
                dataField: 'izveidots', text: 'Izveidots',
                formatter: (cell) => cell ? new Date(cell).toLocaleString('lv-LV') : ''
            }
        ];

        if (isEditable) {
            columns.unshift({
                dataField: 'df1', text: '', isDummyField: true,
                formatter: (_cellContent, row) => (
                    <Button color="secondary" size="sm" onClick={(e) => {
                        e.stopPropagation();
                        this.setState({ editingId: row.id, apraksts: row.apraksts || '' });
                    }}>
                        <i className="fa fa-pencil"></i>
                    </Button>
                ),
                classes: 'td-button', headerStyle: { width: 36 }
            });
            columns.push({
                dataField: 'df2', text: '', isDummyField: true,
                formatter: (_cellContent, row) => (
                    <Button color="danger" size="sm" onClick={(e) => {
                        e.stopPropagation();
                        this.handleDelete(row.id);
                    }}>
                        <i className="fa fa-trash"></i>
                    </Button>
                ),
                classes: 'td-button', headerStyle: { width: 36 }
            });
        }

        return columns;
    }

    render() {
        const { novertejums } = this.props;
        const { preventiviePasakumi, ietekmesPasakumi, editingId, apraksts } = this.state;

        if (!novertejums) {
            return <Alert color="info">Nav datu</Alert>;
        }

        const isEditable = isNovertejumsEditableByUser(novertejums, this.props.user?.tiesibas);

        return (
            <div style={{ maxHeight: 'calc(100vh - 250px)', overflowY: 'auto' }}>
                <FormCard title="Preventīvie pasākumi" size={12}>
                    {preventiviePasakumi.length > 0 ? (
                        <BootstrapTable
                            keyField="id"
                            data={preventiviePasakumi}
                            columns={[{ dataField: 'piezimes', text: 'Pasākums' }]}
                            bootstrap4 striped hover condensed
                        />
                    ) : (
                        <Alert color="info">Nav preventīvo pasākumu</Alert>
                    )}
                </FormCard>

                <FormCard title="Ietekmes mazinošie pasākumi" size={12}>
                    {isEditable && (
                        <div className="mb-3 d-flex">
                            <Input
                                type="textarea"
                                rows="2"
                                value={apraksts}
                                onChange={(e) => this.setState({ apraksts: e.target.value })}
                                placeholder="Ievadiet pasākuma aprakstu..."
                                className="mr-2"
                            />
                            <div className="d-flex flex-column">
                                <Button color="primary" onClick={this.handleSave} disabled={!apraksts.trim()} className="mb-1">
                                    {editingId ? 'Saglabāt' : 'Pievienot'}
                                </Button>
                                {editingId && (
                                    <Button color="secondary" size="sm" onClick={() => this.setState({ editingId: null, apraksts: '' })}>
                                        Atcelt
                                    </Button>
                                )}
                            </div>
                        </div>
                    )}
                    {ietekmesPasakumi.length > 0 ? (
                        <BootstrapTable
                            keyField="id"
                            data={ietekmesPasakumi}
                            columns={this.getIetekmesPasakumiColumns(isEditable)}
                            bootstrap4 striped hover condensed
                        />
                    ) : (
                        <Alert color="info">Nav pievienotu ietekmes mazinošo pasākumu</Alert>
                    )}
                </FormCard>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    novertejums: (state.riskaNovertejumi || {}).selectedItem,
    user: state.user || {}
});

export default connect(mapStateToProps, {
    loadRiskaNovertejumuPasakumi,
    loadRiskaPreventiviePasakumi,
    saveRiskaNovertejumaPasakums,
    deleteRiskaNovertejumaPasakums,
    loadRiskaNovertejums
})(RiskaNovertejumsPasakumi);
